import React from 'react';
import PropTypes from 'prop-types';
import GaleryPhoto from './galeryPhoto';
import {Container, Title, SubTitle, Slides} from './styles';
import {HrLine} from 'ui';

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  arrows: false,
  variableWidth: true,
};

const FormationGalery = ({subTitle, galeryData}) => {
  if (!galeryData || galeryData[0].formation_gallery_photo === false) return null;
  return (
    <Container>
      <Title>Retour sur cette journée</Title>
      <HrLine />
      <SubTitle>{subTitle}</SubTitle>
      <Slides {...settings}>
        {galeryData.map(image => (
          <GaleryPhoto
            type="media"
            key={image.formation_gallery_photo}
            id={image.formation_gallery_photo}
          />
        ))}
      </Slides>
    </Container>
  );
};

FormationGalery.propTypes = {
  galeryData: PropTypes.any,
  subTitle: PropTypes.string,
};

export default FormationGalery;
